import { Injectable } from '@angular/core';
import { Betreuer, Fahrzeug, Gebaeude, Person, Vertreter } from '@pezi/entities';

@Injectable()
export class CompareUtil {

  public static hasSameVersion(versionParam: number, currentPerson: Person | Fahrzeug | Gebaeude): boolean {
    if (!currentPerson) {
      return false;
    }
    if (!versionParam && !currentPerson.version) {
      return true;
    }
    if (!versionParam && currentPerson.version) {
      // Version aktuell, wird nicht über Parameter mitgegeben
      return currentPerson.versionen && currentPerson.versionen.length > 0 && currentPerson.versionen[0].version === currentPerson.version;
    }
    if (versionParam && !currentPerson.version) {
      return false;
    }
    if (versionParam && currentPerson.version) {
      return +versionParam === +currentPerson.version;
    }
    return false;
  }

  public static hasSameBetreuerVertreterVersion(versionParam: number, currentPerson: Betreuer | Vertreter): boolean {
    if (!currentPerson) {
      return false;
    }
    if (!versionParam && !currentPerson.person.version) {
      return true;
    }
    if (!versionParam && currentPerson.person.version) {
      // Version aktuell, wird nicht über Parameter mitgegeben
      return currentPerson.versionen && currentPerson.versionen.length > 0 && currentPerson.versionen[0].version === currentPerson.person.version;
    }
    if (versionParam && !currentPerson.person.version) {
      return false;
    }
    if (versionParam && currentPerson.person.version) {
      return +versionParam === +currentPerson.person.version;
    }
    return false;
  }
}
